import { render, staticRenderFns } from "./userIndex.vue?vue&type=template&id=25138ea4&scoped=true"
import script from "./userIndex.vue?vue&type=script&lang=js"
export * from "./userIndex.vue?vue&type=script&lang=js"
import style0 from "./userIndex.vue?vue&type=style&index=0&id=25138ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25138ea4",
  null
  
)

export default component.exports